import { SharedAngular } from '@Client/@types/sharedAngular';
import { HttpStatusCodes } from '@Shared.Angular/@types/core/contracts/constants/httpStatusCodes';
import { ProcedureViewMode } from '@Shared.Angular/@types/core/contracts/constants/procedureViewMode';
import IProcedureDetail from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureDetail';
import { Guid } from '@Shared.Angular/@types/guid';
import angular from 'angular';
import { IStateParamsService } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

class RunnerPublicSopController {
  procedureId: Guid;
  procedure: IProcedureDetail;
  deniedAccess: boolean;
  editorMode = ProcedureViewMode.Public;

  constructor(
    private $stateParams: IStateParamsService,
    private procedureApiService: SharedAngular.ProcedureApiService,
    private tokenService: SharedAngular.TokenService,
    private redirectService: RedirectService,
    private $state: angular.ui.IStateService
  ) {
    this.procedureId = this.$stateParams.id;
    const tenant = this.tokenService.getTenant();

    this.procedureApiService
      .getPublicProcedure(this.procedureId, tenant?.id)
      .then((procedure) => {
        this.procedure = procedure;
      })
      .catch((error: IResponseError) => {
        if (error.status === HttpStatusCodes.Unauthorized) {
          const sopUrl = `/sop/${this.procedureId}`;
          this.redirectService.setPendingRequestAsUrl(sopUrl);
          this.$state.go(STATE_MAPPINGS.login, { redirectUrl: sopUrl });
        } else {
          this.deniedAccess = true;
        }
      });
  }
}

angular
  .module('flowingly.runner.publicsop')
  .controller('runnerPublicSopController', [
    '$stateParams',
    'procedureApiService',
    'tokenService',
    'redirectService',
    '$state',
    function (
      $stateParams,
      procedureApiService,
      tokenService,
      redirectService,
      $state
    ) {
      const controller = new RunnerPublicSopController(
        $stateParams,
        procedureApiService,
        tokenService,
        redirectService,
        $state
      );
      return controller;
    }
  ]);
